import React from "react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { useNavigate } from "react-router-dom";
import { DeleteLead } from "../services/leadService";
import { useToast } from "../hooks/useToast";

export function DeleteLeadModal({ leadId, open, setOpen }) {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      const res = await DeleteLead(leadId);
      if (res?.success) {
        setOpen(false);
        toast({ title: "Lead deleted successfully" });
        navigate("/leads");
      }
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Failed to delete lead",
      });
    }
  };

  return (
    <AlertDialog.Root open={open} onOpenChange={setOpen}>
      <AlertDialog.Portal>
        {/* Overlay */}
        <AlertDialog.Overlay className="fixed inset-0 bg-black/40 z-40" />

        {/* Content */}
        <AlertDialog.Content className="fixed z-50 left-1/2 top-1/2 w-[90%] max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-lg focus:outline-none">
          <div className="mb-4">
            <AlertDialog.Title className="text-lg font-semibold">
              Warning: Deleting this lead is permanent
            </AlertDialog.Title>
            <AlertDialog.Description className="mt-2 text-sm text-gray-600">
              Once you delete this lead, all their information will be
              permanently removed and cannot be recovered. Please confirm you
              want to proceed.
            </AlertDialog.Description>
          </div>

          <div className="flex justify-end gap-3">
            <AlertDialog.Cancel asChild>
              <button
                type="button"
                className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
            </AlertDialog.Cancel>

            <AlertDialog.Action asChild>
              <button
                type="button"
                className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-600/90"
                onClick={handleDelete}
              >
                Confirm
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
